import { ReactNode } from 'react';
import { createConfirmation } from 'react-confirm';

import ConfirmDialog, { ConfirmDialogOptions } from '../components/ConfirmDialog/ConfirmDialog';

export function confirm(text: ReactNode, options: Omit<ConfirmDialogOptions, 'confirmation'> = {}) {
  return createConfirmation(ConfirmDialog)({ confirmation: text, ...options });
}

export class ConfirmService {
  static delete(title: string, options: Omit<ConfirmDialogOptions, 'confirmation'> = {}) {
    return confirm(title, {
      confirmProps: {
        label: options.confirmProps?.label ?? 'Delete',
      },
    });
  }

  static deleteAllRemarks() {
    return ConfirmService.delete('Are you sure you want to delete all remarks at once?');
  }

  static deleteProject(title?: string) {
    return ConfirmService.delete(`Are you sure you want to delete project "${title ? `${title}` : ''}"?`);
  }

  static deleteSnapshot(title?: string) {
    return ConfirmService.delete(`Are you sure you want to delete snapshot "${title}"?`);
  }
}
